import { useEffect, useState } from 'react';

export const useHasInjectedConnection = () => {
  const [hasInjectedConnection, setHasInjectedConnection] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAleo = () => {
      // @ts-ignore
      if (window.aleo && window.aleo.puzzleWalletClient) {
        setHasInjectedConnection(true);
        setIsLoading(false);
        clearInterval(intervalId); // Stop the interval once defined
      } else {
        setHasInjectedConnection(false);
        setIsLoading(false);
      }
    };

    const intervalId = setInterval(checkAleo, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return { hasInjectedConnection, isLoading };
};
